import { seoFragment } from '@/gql/fragments.gql.js'

import { heroCarouselBlock } from './heroCarousel.gql.js'
import { athleteListGql } from './athlete.gql'
import { buildArticleListGql } from './article.gql.js'

export function buildExploreListingGql (categoryId) {
  const articleListQuery = buildArticleListGql(categoryId)
    .replace(/query.+/, '')
    .replace(/}$/, '')

  const athleteListQuery = athleteListGql
    .replace(/query.+/, '')
    .replace(/}$/, '')

  return `
  query ($offset: IntType!, $limit: IntType!) {
    exploreLanding {
      title
      hero {
        ${heroCarouselBlock}
      }
      categories {
        title
        slug
      }
      ${seoFragment}
    }

    allArticleCategories(first: 100) {
      id
      title
      slug
      hero {
        ${heroCarouselBlock}
      }
      ${seoFragment}
    }

    ${articleListQuery}
    ${athleteListQuery}
  }`
}